import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Close as CloseIcon } from '@mui/icons-material';
import { Text, Theme } from '@simplybenefits/sb-ui-library';
import { styled } from '@mui/system';
import { hideNotification } from '../actions/notifier.js';

const Message = styled('div')(({ theme }) => ({
    color: Theme.colors.surface,
    height: 'auto',
    minHeight: 20,
    padding: 20,
    position: 'fixed',
    top: '2%',
    left: 'calc(50% - 290px)',
    width: 580,
    maxWidth: '90%',
    zIndex: 9999,
    [theme.breakpoints.down(600)]: {
        left: 'calc(50% - 150px)',
        width: 300
    }
}));

/**
 * 
 * @param {*} props 
 * @returns 
 */ 
const Notifier = (props) => {

    /**
     * 
     */
    const _close = () => {
        props.dispatch(hideNotification());
    };

    const styles = {
        errorNotifier: {
            backgroundColor: Theme.colors.red
        },
        messageNotifier: {
            backgroundColor: Theme.colors.brandGreen
        },
        browserNotifier: {
            backgroundColor: Theme.colors.mediumDarkBlue,
            opacity: 0.7
        },
        closeModalIcon: {
            cursor: 'pointer',
            display: 'inline',
            marginTop: -15,
            marginRight: -15,
            fontSize: 22,
            float: 'right',
            color: Theme.colors.surface
        },
        noDecor: {
            textDecorationColor: Theme.colors.surface
        }
    };

    if (!props.showing) {
        return null;
    }

    let messageClassName = '';

    switch (props.notifierType) {
        case 'error':
            messageClassName = styles.errorNotifier; 
            break;
        case 'browser':
            messageClassName = styles.browserNotifier;
            break;
        default:
            messageClassName = styles.messageNotifier;
    }

    return (
        <Message style={messageClassName}>
            <CloseIcon
                style={styles.closeModalIcon}
                onClick={_close}
            />

            <Text
                align="center"
                color={Theme.colors.surface}
                medium
                display="block"
            >
                {props.verbiage}
            </Text>

            <a href={props.link} style={styles.noDecor}>
                <Text
                    align="center"
                    color={Theme.colors.surface}
                    medium
                    display="block"
                >
                    {props.link}
                </Text>
            </a>
        </Message>
    );
};

Notifier.propTypes = {
    dispatch: PropTypes.func,
    verbiage: PropTypes.string,
    notifierType: PropTypes.string,
    link: PropTypes.string,
    showing: PropTypes.bool
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    verbiage: state.notifier.verbiage,
    notifierType: state.notifier.type,
    link: state.notifier.link,
    showing: state.notifier.showing
});

export default connect(mapStateToProps)(Notifier);